// DO NOT EDIT MANUALLY!
// This file is generated, edit `resources/Localizations.json` and run `npm run generate-translation-keys` to update.
import type { TranslationKey } from '~/models';

export const defaultTranslations: Record<TranslationKey, string> = {
  buy: 'Buy',
  choose: 'Choose',
  inclusiveOfAllTaxes: 'Inclusive Of All Taxes',
  lowestPriceText: 'Our lowest price, the last 30 days before current price, was',
  newEdition: 'New edition',
  newEditionAvailable: 'New edition available',
  replace: 'Replace',
  replaceWith: 'Replace with',
  reserve: 'Reserve',
  save: 'Save',
};
